
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"15","height":"15","viewBox":"0 0 15 15"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.462 14.755l-1.826-.515v.234c0 .046 0 .046-.047.046s-.093 0-.093-.046v-.234l-1.826.515h-.047v-.515s0-.047.047-.094 1.31-.983 1.545-1.17c-.047-.187-.281-1.03-.281-2.013v-3.09s-.047-.187-.234-.187c-.047 0-.14 0-.234.047-.234.094-1.639.75-2.996 1.358v1.591l.421.375v.14s0 .047-.047.047h-.046l-.468-.375-.515.375h-.047l-.047-.047v-.094l.468-.468v-1.45L.71 10.307H.66v-.89s0-.187.14-.28a82.65 82.65 0 001.64-1.17s-.048-.562-.048-.796c0-.562.047-.656.047-.656h.328c.047 0 .14.047.14.14v.141c0 .094.047.28.047.468v.421L4.5 6.516s-.047-.515-.047-.796c0-.655.094-.702.14-.702h.281c.047 0 .094 0 .094.14 0 .094.047.422.047.562v.422L6.84 4.55s.094-.047.094-.187v-.094c-.047-1.498 0-3.417.562-4.025h.093c.609.608.655 2.527.562 4.025v.094c0 .14.093.187.093.187l1.826 1.592V5.72c0-.14.047-.468.047-.561 0-.094.093-.14.093-.14h.281c.047 0 .14.046.14.701 0 .234-.046.796-.046.843l1.498 1.17v-.421c0-.187 0-.375.047-.468v-.14c0-.094.046-.141.093-.141h.328s.094.094.047.655c0 .281-.047.843-.047.843.047 0 1.498 1.076 1.638 1.123.14.094.14.281.14.281v.89h-.046L11.802 9.23v1.498l.421.374v.14s0 .048-.047.048h-.046l-.515-.375-.468.375H11.1l-.047-.047v-.094l.421-.468V9.137c-1.357-.655-2.761-1.31-2.995-1.404-.094-.047-.14-.047-.235-.047-.187 0-.234.188-.234.188v3.089c0 .983-.234 1.826-.28 2.013a122.5 122.5 0 011.544 1.17.145.145 0 01.047.094v.468l.14.047z"}})])
          )
        }
      }
    